"use strict";
"use client";

var _excluded = ["__scopeTooltip"],
  _excluded2 = ["forceMount", "side"],
  _excluded3 = ["__scopeTooltip", "children", "aria-label", "onEscapeKeyDown", "onPointerDownOutside"],
  _excluded4 = ["__scopeTooltip"];
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// packages/react/tooltip/src/index.ts
var src_exports = {};
__export(src_exports, {
  Arrow: function Arrow() {
    return Arrow2;
  },
  Content: function Content() {
    return Content2;
  },
  Portal: function Portal() {
    return _Portal;
  },
  Provider: function Provider() {
    return _Provider;
  },
  Root: function Root() {
    return Root3;
  },
  Tooltip: function Tooltip() {
    return _Tooltip;
  },
  TooltipArrow: function TooltipArrow() {
    return _TooltipArrow;
  },
  TooltipContent: function TooltipContent() {
    return _TooltipContent;
  },
  TooltipPortal: function TooltipPortal() {
    return _TooltipPortal;
  },
  TooltipProvider: function TooltipProvider() {
    return _TooltipProvider;
  },
  TooltipTrigger: function TooltipTrigger() {
    return _TooltipTrigger;
  },
  Trigger: function Trigger() {
    return _Trigger;
  },
  createTooltipScope: function createTooltipScope() {
    return _createTooltipScope;
  }
});
module.exports = __toCommonJS(src_exports);

// packages/react/tooltip/src/Tooltip.tsx
var React = __toESM(require("react"));
var import_primitive = require("@radix-ui/primitive");
var import_react_compose_refs = require("@radix-ui/react-compose-refs");
var import_react_context = require("@radix-ui/react-context");
var import_react_dismissable_layer = require("@radix-ui/react-dismissable-layer");
var import_react_id = require("@radix-ui/react-id");
var PopperPrimitive = __toESM(require("@radix-ui/react-popper"));
var import_react_popper = require("@radix-ui/react-popper");
var import_react_portal = require("@radix-ui/react-portal");
var import_react_presence = require("@radix-ui/react-presence");
var import_react_primitive = require("@radix-ui/react-primitive");
var import_react_slot = require("@radix-ui/react-slot");
var import_react_use_controllable_state = require("@radix-ui/react-use-controllable-state");
var VisuallyHiddenPrimitive = __toESM(require("@radix-ui/react-visually-hidden"));
var import_jsx_runtime = require("react/jsx-runtime");
var _ref = (0, import_react_context.createContextScope)("Tooltip", [import_react_popper.createPopperScope]),
  _ref2 = _slicedToArray(_ref, 2),
  createTooltipContext = _ref2[0],
  _createTooltipScope = _ref2[1];
var usePopperScope = (0, import_react_popper.createPopperScope)();
var PROVIDER_NAME = "TooltipProvider";
var DEFAULT_DELAY_DURATION = 700;
var TOOLTIP_OPEN = "tooltip.open";
var _createTooltipContext = createTooltipContext(PROVIDER_NAME),
  _createTooltipContext2 = _slicedToArray(_createTooltipContext, 2),
  TooltipProviderContextProvider = _createTooltipContext2[0],
  useTooltipProviderContext = _createTooltipContext2[1];
var _TooltipProvider = function _TooltipProvider(props) {
  var __scopeTooltip = props.__scopeTooltip,
    _props$delayDuration = props.delayDuration,
    delayDuration = _props$delayDuration === void 0 ? DEFAULT_DELAY_DURATION : _props$delayDuration,
    _props$skipDelayDurat = props.skipDelayDuration,
    skipDelayDuration = _props$skipDelayDurat === void 0 ? 300 : _props$skipDelayDurat,
    _props$disableHoverab = props.disableHoverableContent,
    disableHoverableContent = _props$disableHoverab === void 0 ? false : _props$disableHoverab,
    children = props.children;
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isOpenDelayed = _React$useState2[0],
    setIsOpenDelayed = _React$useState2[1];
  var isPointerInTransitRef = React.useRef(false);
  var skipDelayTimerRef = React.useRef(0);
  React.useEffect(function () {
    var skipDelayTimer = skipDelayTimerRef.current;
    return function () {
      return window.clearTimeout(skipDelayTimer);
    };
  }, []);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(TooltipProviderContextProvider, {
    scope: __scopeTooltip,
    isOpenDelayed: isOpenDelayed,
    delayDuration: delayDuration,
    onOpen: React.useCallback(function () {
      window.clearTimeout(skipDelayTimerRef.current);
      setIsOpenDelayed(false);
    }, []),
    onClose: React.useCallback(function () {
      window.clearTimeout(skipDelayTimerRef.current);
      skipDelayTimerRef.current = window.setTimeout(function () {
        return setIsOpenDelayed(true);
      }, skipDelayDuration);
    }, [skipDelayDuration]),
    isPointerInTransitRef: isPointerInTransitRef,
    onPointerInTransitChange: React.useCallback(function (inTransit) {
      isPointerInTransitRef.current = inTransit;
    }, []),
    disableHoverableContent: disableHoverableContent,
    children: children
  });
};
_TooltipProvider.displayName = PROVIDER_NAME;
var TOOLTIP_NAME = "Tooltip";
var _createTooltipContext3 = createTooltipContext(TOOLTIP_NAME),
  _createTooltipContext4 = _slicedToArray(_createTooltipContext3, 2),
  TooltipContextProvider = _createTooltipContext4[0],
  useTooltipContext = _createTooltipContext4[1];
var _Tooltip = function _Tooltip(props) {
  var __scopeTooltip = props.__scopeTooltip,
    children = props.children,
    openProp = props.open,
    _props$defaultOpen = props.defaultOpen,
    defaultOpen = _props$defaultOpen === void 0 ? false : _props$defaultOpen,
    onOpenChange = props.onOpenChange,
    disableHoverableContentProp = props.disableHoverableContent,
    delayDurationProp = props.delayDuration;
  var providerContext = useTooltipProviderContext(TOOLTIP_NAME, props.__scopeTooltip);
  var popperScope = usePopperScope(__scopeTooltip);
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    trigger = _React$useState4[0],
    setTrigger = _React$useState4[1];
  var contentId = (0, import_react_id.useId)();
  var openTimerRef = React.useRef(0);
  var disableHoverableContent = disableHoverableContentProp !== null && disableHoverableContentProp !== void 0 ? disableHoverableContentProp : providerContext.disableHoverableContent;
  var delayDuration = delayDurationProp !== null && delayDurationProp !== void 0 ? delayDurationProp : providerContext.delayDuration;
  var wasOpenDelayedRef = React.useRef(false);
  var _ref3 = (0, import_react_use_controllable_state.useControllableState)({
      prop: openProp,
      defaultProp: defaultOpen,
      onChange: function onChange(open2) {
        if (open2) {
          providerContext.onOpen();
          document.dispatchEvent(new CustomEvent(TOOLTIP_OPEN));
        } else {
          providerContext.onClose();
        }
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(open2);
      }
    }),
    _ref4 = _slicedToArray(_ref3, 2),
    _ref4$ = _ref4[0],
    open = _ref4$ === void 0 ? false : _ref4$,
    setOpen = _ref4[1];
  var stateAttribute = React.useMemo(function () {
    return open ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
  }, [open]);
  var handleOpen = React.useCallback(function () {
    window.clearTimeout(openTimerRef.current);
    openTimerRef.current = 0;
    wasOpenDelayedRef.current = false;
    setOpen(true);
  }, [setOpen]);
  var handleClose = React.useCallback(function () {
    window.clearTimeout(openTimerRef.current);
    openTimerRef.current = 0;
    setOpen(false);
  }, [setOpen]);
  var handleDelayedOpen = React.useCallback(function () {
    window.clearTimeout(openTimerRef.current);
    openTimerRef.current = window.setTimeout(function () {
      wasOpenDelayedRef.current = true;
      setOpen(true);
      openTimerRef.current = 0;
    }, delayDuration);
  }, [delayDuration, setOpen]);
  React.useEffect(function () {
    return function () {
      if (openTimerRef.current) {
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = 0;
      }
    };
  }, []);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(PopperPrimitive.Root, _objectSpread(_objectSpread({}, popperScope), {}, {
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(TooltipContextProvider, {
      scope: __scopeTooltip,
      contentId: contentId,
      open: open,
      stateAttribute: stateAttribute,
      trigger: trigger,
      onTriggerChange: setTrigger,
      onTriggerEnter: React.useCallback(function () {
        if (providerContext.isOpenDelayed) handleDelayedOpen();else handleOpen();
      }, [providerContext.isOpenDelayed, handleDelayedOpen, handleOpen]),
      onTriggerLeave: React.useCallback(function () {
        if (disableHoverableContent) {
          handleClose();
        } else {
          window.clearTimeout(openTimerRef.current);
          openTimerRef.current = 0;
        }
      }, [handleClose, disableHoverableContent]),
      onOpen: handleOpen,
      onClose: handleClose,
      disableHoverableContent: disableHoverableContent,
      children: children
    })
  }));
};
_Tooltip.displayName = TOOLTIP_NAME;
var TRIGGER_NAME = "TooltipTrigger";
var _TooltipTrigger = React.forwardRef(function (props, forwardedRef) {
  var __scopeTooltip = props.__scopeTooltip,
    triggerProps = _objectWithoutProperties(props, _excluded);
  var context = useTooltipContext(TRIGGER_NAME, __scopeTooltip);
  var providerContext = useTooltipProviderContext(TRIGGER_NAME, __scopeTooltip);
  var popperScope = usePopperScope(__scopeTooltip);
  var ref = React.useRef(null);
  var composedRefs = (0, import_react_compose_refs.useComposedRefs)(forwardedRef, ref, context.onTriggerChange);
  var isPointerDownRef = React.useRef(false);
  var hasPointerMoveOpenedRef = React.useRef(false);
  var handlePointerUp = React.useCallback(function () {
    return isPointerDownRef.current = false;
  }, []);
  React.useEffect(function () {
    return function () {
      return document.removeEventListener("pointerup", handlePointerUp);
    };
  }, [handlePointerUp]);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(PopperPrimitive.Anchor, _objectSpread(_objectSpread({
    asChild: true
  }, popperScope), {}, {
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_primitive.Primitive.button, _objectSpread(_objectSpread({
      "aria-describedby": context.open ? context.contentId : void 0,
      "data-state": context.stateAttribute
    }, triggerProps), {}, {
      ref: composedRefs,
      onPointerMove: (0, import_primitive.composeEventHandlers)(props.onPointerMove, function (event) {
        if (event.pointerType === "touch") return;
        if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
          context.onTriggerEnter();
          hasPointerMoveOpenedRef.current = true;
        }
      }),
      onPointerLeave: (0, import_primitive.composeEventHandlers)(props.onPointerLeave, function () {
        context.onTriggerLeave();
        hasPointerMoveOpenedRef.current = false;
      }),
      onPointerDown: (0, import_primitive.composeEventHandlers)(props.onPointerDown, function () {
        isPointerDownRef.current = true;
        document.addEventListener("pointerup", handlePointerUp, {
          once: true
        });
      }),
      onFocus: (0, import_primitive.composeEventHandlers)(props.onFocus, function () {
        if (!isPointerDownRef.current) context.onOpen();
      }),
      onBlur: (0, import_primitive.composeEventHandlers)(props.onBlur, context.onClose),
      onClick: (0, import_primitive.composeEventHandlers)(props.onClick, context.onClose)
    }))
  }));
});
_TooltipTrigger.displayName = TRIGGER_NAME;
var PORTAL_NAME = "TooltipPortal";
var _createTooltipContext5 = createTooltipContext(PORTAL_NAME, {
    forceMount: void 0
  }),
  _createTooltipContext6 = _slicedToArray(_createTooltipContext5, 2),
  PortalProvider = _createTooltipContext6[0],
  usePortalContext = _createTooltipContext6[1];
var _TooltipPortal = function _TooltipPortal(props) {
  var __scopeTooltip = props.__scopeTooltip,
    forceMount = props.forceMount,
    children = props.children,
    container = props.container;
  var context = useTooltipContext(PORTAL_NAME, __scopeTooltip);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(PortalProvider, {
    scope: __scopeTooltip,
    forceMount: forceMount,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_presence.Presence, {
      present: forceMount || context.open,
      children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_portal.Portal, {
        asChild: true,
        container: container,
        children: children
      })
    })
  });
};
_TooltipPortal.displayName = PORTAL_NAME;
var CONTENT_NAME = "TooltipContent";
var _TooltipContent = React.forwardRef(function (props, forwardedRef) {
  var portalContext = usePortalContext(CONTENT_NAME, props.__scopeTooltip);
  var _props$forceMount = props.forceMount,
    forceMount = _props$forceMount === void 0 ? portalContext.forceMount : _props$forceMount,
    _props$side = props.side,
    side = _props$side === void 0 ? "top" : _props$side,
    contentProps = _objectWithoutProperties(props, _excluded2);
  var context = useTooltipContext(CONTENT_NAME, props.__scopeTooltip);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_presence.Presence, {
    present: forceMount || context.open,
    children: context.disableHoverableContent ? /* @__PURE__ */(0, import_jsx_runtime.jsx)(TooltipContentImpl, _objectSpread(_objectSpread({
      side: side
    }, contentProps), {}, {
      ref: forwardedRef
    })) : /* @__PURE__ */(0, import_jsx_runtime.jsx)(TooltipContentHoverable, _objectSpread(_objectSpread({
      side: side
    }, contentProps), {}, {
      ref: forwardedRef
    }))
  });
});
var TooltipContentHoverable = React.forwardRef(function (props, forwardedRef) {
  var context = useTooltipContext(CONTENT_NAME, props.__scopeTooltip);
  var providerContext = useTooltipProviderContext(CONTENT_NAME, props.__scopeTooltip);
  var ref = React.useRef(null);
  var composedRefs = (0, import_react_compose_refs.useComposedRefs)(forwardedRef, ref);
  var _React$useState5 = React.useState(null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    pointerGraceArea = _React$useState6[0],
    setPointerGraceArea = _React$useState6[1];
  var trigger = context.trigger,
    onClose = context.onClose;
  var content = ref.current;
  var onPointerInTransitChange = providerContext.onPointerInTransitChange;
  var handleRemoveGraceArea = React.useCallback(function () {
    setPointerGraceArea(null);
    onPointerInTransitChange(false);
  }, [onPointerInTransitChange]);
  var handleCreateGraceArea = React.useCallback(function (event, hoverTarget) {
    var currentTarget = event.currentTarget;
    var exitPoint = {
      x: event.clientX,
      y: event.clientY
    };
    var exitSide = getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
    var paddedExitPoints = getPaddedExitPoints(exitPoint, exitSide);
    var hoverTargetPoints = getPointsFromRect(hoverTarget.getBoundingClientRect());
    var graceArea = getHull([].concat(_toConsumableArray(paddedExitPoints), _toConsumableArray(hoverTargetPoints)));
    setPointerGraceArea(graceArea);
    onPointerInTransitChange(true);
  }, [onPointerInTransitChange]);
  React.useEffect(function () {
    return function () {
      return handleRemoveGraceArea();
    };
  }, [handleRemoveGraceArea]);
  React.useEffect(function () {
    if (trigger && content) {
      var handleTriggerLeave = function handleTriggerLeave(event) {
        return handleCreateGraceArea(event, content);
      };
      var handleContentLeave = function handleContentLeave(event) {
        return handleCreateGraceArea(event, trigger);
      };
      trigger.addEventListener("pointerleave", handleTriggerLeave);
      content.addEventListener("pointerleave", handleContentLeave);
      return function () {
        trigger.removeEventListener("pointerleave", handleTriggerLeave);
        content.removeEventListener("pointerleave", handleContentLeave);
      };
    }
  }, [trigger, content, handleCreateGraceArea, handleRemoveGraceArea]);
  React.useEffect(function () {
    if (pointerGraceArea) {
      var handleTrackPointerGrace = function handleTrackPointerGrace(event) {
        var target = event.target;
        var pointerPosition = {
          x: event.clientX,
          y: event.clientY
        };
        var hasEnteredTarget = (trigger === null || trigger === void 0 ? void 0 : trigger.contains(target)) || (content === null || content === void 0 ? void 0 : content.contains(target));
        var isPointerOutsideGraceArea = !isPointInPolygon(pointerPosition, pointerGraceArea);
        if (hasEnteredTarget) {
          handleRemoveGraceArea();
        } else if (isPointerOutsideGraceArea) {
          handleRemoveGraceArea();
          onClose();
        }
      };
      document.addEventListener("pointermove", handleTrackPointerGrace);
      return function () {
        return document.removeEventListener("pointermove", handleTrackPointerGrace);
      };
    }
  }, [trigger, content, pointerGraceArea, onClose, handleRemoveGraceArea]);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(TooltipContentImpl, _objectSpread(_objectSpread({}, props), {}, {
    ref: composedRefs
  }));
});
var _createTooltipContext7 = createTooltipContext(TOOLTIP_NAME, {
    isInside: false
  }),
  _createTooltipContext8 = _slicedToArray(_createTooltipContext7, 2),
  VisuallyHiddenContentContextProvider = _createTooltipContext8[0],
  useVisuallyHiddenContentContext = _createTooltipContext8[1];
var TooltipContentImpl = React.forwardRef(function (props, forwardedRef) {
  var __scopeTooltip = props.__scopeTooltip,
    children = props.children,
    ariaLabel = props["aria-label"],
    onEscapeKeyDown = props.onEscapeKeyDown,
    onPointerDownOutside = props.onPointerDownOutside,
    contentProps = _objectWithoutProperties(props, _excluded3);
  var context = useTooltipContext(CONTENT_NAME, __scopeTooltip);
  var popperScope = usePopperScope(__scopeTooltip);
  var onClose = context.onClose;
  React.useEffect(function () {
    document.addEventListener(TOOLTIP_OPEN, onClose);
    return function () {
      return document.removeEventListener(TOOLTIP_OPEN, onClose);
    };
  }, [onClose]);
  React.useEffect(function () {
    if (context.trigger) {
      var handleScroll = function handleScroll(event) {
        var target = event.target;
        if (target !== null && target !== void 0 && target.contains(context.trigger)) onClose();
      };
      window.addEventListener("scroll", handleScroll, {
        capture: true
      });
      return function () {
        return window.removeEventListener("scroll", handleScroll, {
          capture: true
        });
      };
    }
  }, [context.trigger, onClose]);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_dismissable_layer.DismissableLayer, {
    asChild: true,
    disableOutsidePointerEvents: false,
    onEscapeKeyDown: onEscapeKeyDown,
    onPointerDownOutside: onPointerDownOutside,
    onFocusOutside: function onFocusOutside(event) {
      return event.preventDefault();
    },
    onDismiss: onClose,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsxs)(PopperPrimitive.Content, _objectSpread(_objectSpread(_objectSpread({
      "data-state": context.stateAttribute
    }, popperScope), contentProps), {}, {
      ref: forwardedRef,
      style: _objectSpread(_objectSpread({}, contentProps.style), {
        "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
        "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
        "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
      }),
      children: [/* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_slot.Slottable, {
        children: children
      }), /* @__PURE__ */(0, import_jsx_runtime.jsx)(VisuallyHiddenContentContextProvider, {
        scope: __scopeTooltip,
        isInside: true,
        children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(VisuallyHiddenPrimitive.Root, {
          id: context.contentId,
          role: "tooltip",
          children: ariaLabel || children
        })
      })]
    }))
  });
});
_TooltipContent.displayName = CONTENT_NAME;
var ARROW_NAME = "TooltipArrow";
var _TooltipArrow = React.forwardRef(function (props, forwardedRef) {
  var __scopeTooltip = props.__scopeTooltip,
    arrowProps = _objectWithoutProperties(props, _excluded4);
  var popperScope = usePopperScope(__scopeTooltip);
  var visuallyHiddenContentContext = useVisuallyHiddenContentContext(ARROW_NAME, __scopeTooltip);
  return visuallyHiddenContentContext.isInside ? null : /* @__PURE__ */(0, import_jsx_runtime.jsx)(PopperPrimitive.Arrow, _objectSpread(_objectSpread(_objectSpread({}, popperScope), arrowProps), {}, {
    ref: forwardedRef
  }));
});
_TooltipArrow.displayName = ARROW_NAME;
function getExitSideFromRect(point, rect) {
  var top = Math.abs(rect.top - point.y);
  var bottom = Math.abs(rect.bottom - point.y);
  var right = Math.abs(rect.right - point.x);
  var left = Math.abs(rect.left - point.x);
  switch (Math.min(top, bottom, right, left)) {
    case left:
      return "left";
    case right:
      return "right";
    case top:
      return "top";
    case bottom:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function getPaddedExitPoints(exitPoint, exitSide) {
  var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
  var paddedExitPoints = [];
  switch (exitSide) {
    case "top":
      paddedExitPoints.push({
        x: exitPoint.x - padding,
        y: exitPoint.y + padding
      }, {
        x: exitPoint.x + padding,
        y: exitPoint.y + padding
      });
      break;
    case "bottom":
      paddedExitPoints.push({
        x: exitPoint.x - padding,
        y: exitPoint.y - padding
      }, {
        x: exitPoint.x + padding,
        y: exitPoint.y - padding
      });
      break;
    case "left":
      paddedExitPoints.push({
        x: exitPoint.x + padding,
        y: exitPoint.y - padding
      }, {
        x: exitPoint.x + padding,
        y: exitPoint.y + padding
      });
      break;
    case "right":
      paddedExitPoints.push({
        x: exitPoint.x - padding,
        y: exitPoint.y - padding
      }, {
        x: exitPoint.x - padding,
        y: exitPoint.y + padding
      });
      break;
  }
  return paddedExitPoints;
}
function getPointsFromRect(rect) {
  var top = rect.top,
    right = rect.right,
    bottom = rect.bottom,
    left = rect.left;
  return [{
    x: left,
    y: top
  }, {
    x: right,
    y: top
  }, {
    x: right,
    y: bottom
  }, {
    x: left,
    y: bottom
  }];
}
function isPointInPolygon(point, polygon) {
  var x = point.x,
    y = point.y;
  var inside = false;
  for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    var xi = polygon[i].x;
    var yi = polygon[i].y;
    var xj = polygon[j].x;
    var yj = polygon[j].y;
    var intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}
function getHull(points) {
  var newPoints = points.slice();
  newPoints.sort(function (a, b) {
    if (a.x < b.x) return -1;else if (a.x > b.x) return 1;else if (a.y < b.y) return -1;else if (a.y > b.y) return 1;else return 0;
  });
  return getHullPresorted(newPoints);
}
function getHullPresorted(points) {
  if (points.length <= 1) return points.slice();
  var upperHull = [];
  for (var i = 0; i < points.length; i++) {
    var p = points[i];
    while (upperHull.length >= 2) {
      var q = upperHull[upperHull.length - 1];
      var r = upperHull[upperHull.length - 2];
      if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) upperHull.pop();else break;
    }
    upperHull.push(p);
  }
  upperHull.pop();
  var lowerHull = [];
  for (var _i = points.length - 1; _i >= 0; _i--) {
    var _p = points[_i];
    while (lowerHull.length >= 2) {
      var _q = lowerHull[lowerHull.length - 1];
      var _r = lowerHull[lowerHull.length - 2];
      if ((_q.x - _r.x) * (_p.y - _r.y) >= (_q.y - _r.y) * (_p.x - _r.x)) lowerHull.pop();else break;
    }
    lowerHull.push(_p);
  }
  lowerHull.pop();
  if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) {
    return upperHull;
  } else {
    return upperHull.concat(lowerHull);
  }
}
var _Provider = _TooltipProvider;
var Root3 = _Tooltip;
var _Trigger = _TooltipTrigger;
var _Portal = _TooltipPortal;
var Content2 = _TooltipContent;
var Arrow2 = _TooltipArrow;